import { render, staticRenderFns } from "./edutalk-register-work.vue?vue&type=template&id=af861648"
import script from "./edutalk-register-work.vue?vue&type=script&lang=js"
export * from "./edutalk-register-work.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports